import React, {PropTypes} from 'react';
import FormattedNumberInput from '../formatted-number-input/';
import ValidationAndVsrErrorMessages from '../../../claim/shared/components/validation-and-vsr-error-messages';

const FormattedNumberInputWithErrors = props => {

    const {errorMessage, isValid, vsrMessage, ...rest} = props;

    return (
        <span>
            <FormattedNumberInput
                {...rest}
            />
            <ValidationAndVsrErrorMessages
                errorMessage={errorMessage}
                isValid={isValid}
                vsrMessage={vsrMessage}
            />
        </span>

    );

};

FormattedNumberInputWithErrors.displayName = 'FormattedNumberInputWithErrors';
FormattedNumberInputWithErrors.propTypes = {
    errorMessage: PropTypes.string,
    isValid: PropTypes.bool,
    vsrMessage: PropTypes.string
};
FormattedNumberInputWithErrors.defaultProps = {
    className: 'formatted-number-input-with-errors'
};

export default FormattedNumberInputWithErrors;



// WEBPACK FOOTER //
// ./src/shared/components/format-number-input-with-errors/index.js